export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13665.05d3a5ab.jpg";